
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { RecipesProvider } from "@/contexts/RecipesContext";
import { MenuProvider } from "@/contexts/menu";
import ProtectedRoute from "@/components/ProtectedRoute";
import Index from "./pages/Index";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import WeeklyMenu from "./pages/WeeklyMenu";
import ShoppingList from "./pages/ShoppingList";
import Favorites from "./pages/Favorites";
import Profile from "./pages/Profile";
import UserProfile from "./pages/UserProfile";
import Subscription from "./pages/Subscription";
import Support from "./pages/Support";
import Tutorials from "./pages/Tutorials";
import PasswordReset from "./pages/PasswordReset";
import UpdatePassword from "./pages/UpdatePassword";
import Unauthorized from "./pages/Unauthorized";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import DiarioNutricional from "./pages/DiarioNutricional";
import Nutrition from "./pages/Nutrition";
import Notifications from "./pages/Notifications";
import Challenges from "./pages/Challenges";
import ReferralProgram from "./pages/ReferralProgram";
import Explore from "./pages/Explore";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminRecipes from "./pages/admin/AdminRecipes";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminStatistics from "./pages/admin/Statistics";
import AdminNotifications from "./pages/admin/Notifications";
import AdminImportRecipes from "./pages/admin/ImportRecipes";
import AdminRecipeForm from "./pages/admin/RecipeForm";
import AdminTutorials from "./pages/admin/Tutorials";
import "./App.css";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <RecipesProvider>
            <MenuProvider>
              <Toaster />
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/registro" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/recetas" element={<ProtectedRoute><Recipes /></ProtectedRoute>} />
                  <Route path="/receta/:id" element={<ProtectedRoute><RecipeDetail /></ProtectedRoute>} />
                  <Route path="/menu-semanal" element={<ProtectedRoute><WeeklyMenu /></ProtectedRoute>} />
                  <Route path="/lista-compra" element={<ProtectedRoute><ShoppingList /></ProtectedRoute>} />
                  <Route path="/favoritos" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
                  <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/user/:userId" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
                  <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
                  <Route path="/soporte" element={<ProtectedRoute><Support /></ProtectedRoute>} />
                  <Route path="/tutoriales" element={<ProtectedRoute><Tutorials /></ProtectedRoute>} />
                  <Route path="/password-reset" element={<PasswordReset />} />
                  <Route path="/update-password" element={<UpdatePassword />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                  <Route path="/diario-nutricional" element={<ProtectedRoute><DiarioNutricional /></ProtectedRoute>} />
                  <Route path="/nutricion" element={<ProtectedRoute><Nutrition /></ProtectedRoute>} />
                  <Route path="/notificaciones" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                  <Route path="/challenges" element={<ProtectedRoute><Challenges /></ProtectedRoute>} />
                  <Route path="/programa-referidos" element={<ProtectedRoute><ReferralProgram /></ProtectedRoute>} />
                  <Route path="/explora" element={<ProtectedRoute><Explore /></ProtectedRoute>} />
                  
                  {/* Admin Routes - All protected with admin requirement */}
                  <Route path="/admin/dashboard" element={<ProtectedRoute requireAdmin={true}><AdminDashboard /></ProtectedRoute>} />
                  <Route path="/admin/recipes" element={<ProtectedRoute requireAdmin={true}><AdminRecipes /></ProtectedRoute>} />
                  <Route path="/admin/users" element={<ProtectedRoute requireAdmin={true}><AdminUsers /></ProtectedRoute>} />
                  <Route path="/admin/statistics" element={<ProtectedRoute requireAdmin={true}><AdminStatistics /></ProtectedRoute>} />
                  <Route path="/admin/notifications" element={<ProtectedRoute requireAdmin={true}><AdminNotifications /></ProtectedRoute>} />
                  <Route path="/admin/import-recipes" element={<ProtectedRoute requireAdmin={true}><AdminImportRecipes /></ProtectedRoute>} />
                  <Route path="/admin/recipe/new" element={<ProtectedRoute requireAdmin={true}><AdminRecipeForm /></ProtectedRoute>} />
                  <Route path="/admin/recipe/:id" element={<ProtectedRoute requireAdmin={true}><AdminRecipeForm /></ProtectedRoute>} />
                  <Route path="/admin/tutorials" element={<ProtectedRoute requireAdmin={true}><AdminTutorials /></ProtectedRoute>} />
                  
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
            </MenuProvider>
          </RecipesProvider>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
